const isMissing = (value) => value === void 1;

// noinspection JSUnusedGlobalSymbols
export default isMissing;
